module["exports"] = [
  "შპს",
  "სს",
  "ააიპ",
  "სსიპ"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/company/prefix.js
 ** module id = 734
 ** module chunks = 0
 **/